import { useRouter } from 'next/router';
import { useEffect } from 'react';

export default function Home() {
  const router = useRouter();

  useEffect(() => {
    // クライアントサイドでのリダイレクト
    router.replace('/account-before-confirm');
  }, [router]);

  // リダイレクト中はローディング表示または何も表示しない
  return null;
}